var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.06 26.325C32.43 26.94 32.07 27.825 32.16 28.77C32.295 30.39 33.78 31.575 35.4 31.575H38.25V33.36C38.25 36.465 35.715 39 32.61 39H15.39C12.285 39 9.75 36.465 9.75 33.36V23.265C9.75 20.16 12.285 17.625 15.39 17.625H32.61C35.715 17.625 38.25 20.16 38.25 23.265V25.425H35.22C34.38 25.425 33.615 25.755 33.06 26.325Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.275 11.9254V17.6254H15.39C12.285 17.6254 9.75 20.1604 9.75 23.2654V17.7605C9.75 15.9755 10.845 14.3854 12.51 13.7554L24.42 9.25539C26.28 8.56539 28.275 9.93043 28.275 11.9254Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8402 26.9557V30.0458C39.8402 30.8708 39.1802 31.5457 38.3402 31.5757H35.4002C33.7802 31.5757 32.2952 30.3908 32.1602 28.7708C32.0702 27.8258 32.4302 26.9407 33.0602 26.3257C33.6152 25.7557 34.3802 25.4258 35.2202 25.4258H38.3402C39.1802 25.4558 39.8402 26.1307 39.8402 26.9557Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.125H16.5C15.885 25.125 15.375 24.615 15.375 24C15.375 23.385 15.885 22.875 16.5 22.875H27C27.615 22.875 28.125 23.385 28.125 24C28.125 24.615 27.615 25.125 27 25.125Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.eb8ba1da71bd51ea015007b5edd90855.svg";
export { ForwardRef as ReactComponent };